{
    "404": "Oh noes! We have searched the sea and we can't find thee page!",
    "appError": {
        "title": "Something went wrong",
        "description": "The app ran into an unexpected problem. Try reloading, or head back to your workspace. If this keeps happening, please contact support.",
        "home": "Back to Workspace"
    }
}
